export default __webpack_public_path__ + "static/media/electrek-bike-charge-cafe.2705e828.svg";